/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useParams } from 'react-router-dom';
import useProcedures from './useProcedures';

/**
 * Hook to return the currently used procedure from the route parameters.
 * The result delivers the procedure object of the current URL procedure.
 */
export default function useProcedure(procedureId) {
  const { procedure = procedureId } = useParams();
  const { getProcedure } = useProcedures();

  if (procedure) {
    return getProcedure(procedure) || { id: procedure, category: procedure };
  }

  return null;
}
